var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.316 12.0108C11.1209 13.2361 9.44258 14 7.57909 14C3.93564 14 1 11.08 1 7.5C1 3.92001 3.93564 1 7.57909 1C9.44258 1 11.1209 1.76387 12.316 2.98921V1.64496C11.0185 0.615673 9.37144 0 7.57909 0C3.39327 0 0 3.35786 0 7.5C0 11.6421 3.39327 15 7.57909 15C9.37144 15 11.0185 14.3843 12.316 13.355V12.0108Z",
    fill: "#7B7DFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89453 7.49897L18 7.49897M18 7.49897L13.9578 3.58594M18 7.49897L13.9578 11.412",
    stroke: "#7B7DFC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logout.231d7d383436ae6be77068a0a16eb6e8.svg";